/** Navigation order; the first view is also the default for missing/invalid URLs. */
export const CASH_FLOW_VIEWS = [
  { slug: "sankey-flow", label: "Sankey flow", icon: "account_tree" },
  {
    slug: "category-breakdown",
    label: "Category breakdown",
    icon: "align_horizontal_left",
  },
  { slug: "historical-trends", label: "Historical trends", icon: "monitoring" },
  { slug: "top-merchants", label: "Top merchants", icon: "storefront" },
] as const;

// Adding a view also requires a renderer in CashFlowScreen.
export type CashFlowView = (typeof CASH_FLOW_VIEWS)[number]["slug"];

export function cashFlowViewPath(view: CashFlowView): string {
  return `/cash-flow/${view}`;
}
